import { render, staticRenderFns } from "./ProdutoTabList.vue?vue&type=template&id=cde4367a&scoped=true"
import script from "./ProdutoTabList.vue?vue&type=script&lang=js"
export * from "./ProdutoTabList.vue?vue&type=script&lang=js"
import style0 from "./ProdutoTabList.vue?vue&type=style&index=0&id=cde4367a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cde4367a",
  null
  
)

export default component.exports